/**
 * Corresponds to the deprecated Chakra LinkProp `isExternal`, which safely
 * causes a link to be opened in a new tab.
 *
 * The `isExternal` prop is not available if you are composing with a
 * polymorphic component like Button, so spread this in instead:
 *
 * @example
 * ```tsx
 * import { Button } from '@chakra-ui/react';
 * import { Link, RouterLink } from '@burnsred/ui-chakra';
 *
 * // ❌ Warning: Function components cannot be given refs.
 * <Button as={Link} to="/" variant="primary" isExternal />
 *
 * // ✅ spread these props in instead
 * <Button as={RouterLink} to="/" variant="primary" {...isExternal} />
 * ```
 *
 * @see https://v2.chakra-ui.com/docs/components/link/usage#external-link
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/a#security_and_privacy
 */
export const isExternal = {
  target: '_blank',
  rel: 'noreferrer noopener',
} as const;
